import { ErrorResponseWrapper } from "@apis/errors/error-response-wrapper";
import config from "../environment/environment-config";
import { TtGetQuoteToOrderRequest } from "@apis/requests/tt-get-quote-to-order-request";
import { TtGetQuoteToOrderResponse } from "@apis/responses/tt-get-quote-to-order-response";
import {
  ITtQuoteDetail,
  ITtQuote,
  ITtAddQuoteToOrderToCartRequest,
  TtSortByOption,
  AggregationTypes,
} from "@apis/model/tt-quote-to-order";
import { getContentDispositionFileName } from "@globals/helpers/tt-data-processing-service";

export const FETCH_QUOTE_TO_ORDER_BEGIN = "FETCH_QUOTE_TO_ORDER_BEGIN";
export const FETCH_QUOTE_TO_ORDER_SUCCESS = "FETCH_QUOTE_TO_ORDER_SUCCESS";
export const FETCH_QUOTE_TO_ORDER_FAILURE = "FETCH_QUOTE_TO_ORDER_FAILURE";
export const FETCH_QUOT_TO_ORDER_DETAILS_BEGIN =
  "FETCH_QUOT_TO_ORDER_DETAILS_BEGIN";
export const FETCH_QUOT_TO_ORDER_DETAILS_SUCCESS =
  "FETCH_QUOT_TO_ORDER_DETAILS_SUCCESS";
export const FETCH_QUOT_TO_ORDER_DETAILS_FAILURE =
  "FETCH_QUOT_TO_ORDER_DETAILS_FAILURE";
export const CHANGE_QUOT_TO_ORDER_DETAILS_QUONTITY =
  "CHANGE_QUOT_TO_ORDER_DETAILS_QUONTITY";
export const CHANGE_QUONTITY_VALUE = "CHANGE_QUONTITY_VALUE";
export const ADD_QUOTE_TO_ORDER_TO_CART_BEGIN =
  "ADD_QUOTE_TO_ORDER_TO_CART_BEGIN";
export const ADD_QUOTE_TO_ORDER_TO_CART_SUCCESS =
  "ADD_QUOTE_TO_ORDER_TO_CART_SUCCESS";
export const ADD_QUOTE_TO_ORDER_TO_CART_FAILURE =
  "ADD_QUOTE_TO_ORDER_TO_CART_FAILURE";
export const UPDATE_QUOTE_TO_ORDER_SELECTED_ITEMS =
  "UPDATE_QUOTE_TO_ORDER_SELECTED_ITEMS";
export const FETCH_QUOTE_TO_ORDER_BAD_REQUEST_FAILURE =
  "FETCH_QUOTE_TO_ORDER_BAD_REQUEST_FAILURE";
export const DOWNLOAD_QUOTE_TO_ORDER_FAILURE =
  "DOWNLOAD_QUOTE_TO_ORDER_FAILURE";
export const DOWNLOAD_QUOTE_TO_ORDER_BEGIN = "DOWNLOAD_QUOTE_TO_ORDER_BEGIN";
export const DOWNLOAD_QUOTE_TO_ORDER_SUCCESS =
  "DOWNLOAD_QUOTE_TO_ORDER_SUCCESS";
export const DOWNLOAD_QUOTE_TO_ORDER_NOT_FOUND_FAILURE =
  "DOWNLOAD_QUOTE_TO_ORDER_NOT_FOUND_FAILURE";
export const TOGGLE_ERROR_MODAL = "TOGGLE_ERROR_MODAL";
export const QUOTE_TO_ORDER_BASE_URL = config.apiUrls.quoteToOrderApi;
export const UPDATE_SORT = "UPDATE_SORT";
export const SET_AGGREGATION_ENABLED_DEFAULT_VALUE =
  "SET_AGGREGATION_ENABLED_DEFAULT_VALUE";
export const SET_AGGREGATION_TYPE = "SET_AGGREGATION_TYPE";

export const fetchQuoteToOrderBegin = (request: TtGetQuoteToOrderRequest) => ({
  type: FETCH_QUOTE_TO_ORDER_BEGIN,
  payload: request,
});

export const fetchQuoteToOrderSuccess = (
  ttQuoteToOrderResponse: TtGetQuoteToOrderResponse
) => ({
  type: FETCH_QUOTE_TO_ORDER_SUCCESS,
  payload: { ttQuoteToOrderResponse },
});

export const fetchQuoteToOrderFailure = (errors) => ({
  type: FETCH_QUOTE_TO_ORDER_FAILURE,
  payload: { errors },
});

export const fetchQuoteToOrderBadRequestFailure = (errors) => ({
  type: FETCH_QUOTE_TO_ORDER_BAD_REQUEST_FAILURE,
  payload: { errors },
});

export function getQuoteToOrder(
  request: TtGetQuoteToOrderRequest,
  merge = false,
  quotes: Array<ITtQuote>
) {
  const url = QUOTE_TO_ORDER_BASE_URL + request.toQueryString();
  return (dispatch) => {
    dispatch(fetchQuoteToOrderBegin(request));
    return fetch(url, { credentials: "same-origin" })
      .then((res) => {
        if (!res.ok) {
          throw new ErrorResponseWrapper(res);
        }
        return res.json();
      })
      .then((data) => {
        if (merge) {
          data.quotes = [...quotes, ...data.quotes];
        }
        dispatch(fetchQuoteToOrderSuccess(data));
      })
      .catch((errorResponse: ErrorResponseWrapper) => {
        errorResponse.getTTErrorMessages().then((messages) => {
          messages.isBadRequestError
            ? dispatch(fetchQuoteToOrderBadRequestFailure(messages))
            : dispatch(fetchQuoteToOrderFailure(messages));
        });
      });
  };
}

export const fetchTTQuotToOrderDetailsBegin = () => ({
  type: FETCH_QUOT_TO_ORDER_DETAILS_BEGIN,
});

export const fetchTTQuotToOrderDetailsSuccess = (
  quotationDetailResponse: ITtQuoteDetail
) => ({
  type: FETCH_QUOT_TO_ORDER_DETAILS_SUCCESS,
  payload: { quotationDetailResponse },
});

export const fetchTTQuotToOrderDetailsFailure = (errors) => ({
  type: FETCH_QUOT_TO_ORDER_DETAILS_FAILURE,
  payload: { errors: errors },
});

export const changeTTQuotToOrderDetailsQuontity = (
  quontityChanged = false
) => ({
  type: CHANGE_QUOT_TO_ORDER_DETAILS_QUONTITY,
  payload: { quontityChanged },
});

export const changeTTQuotToOrderValue = (position, value) => ({
  type: CHANGE_QUONTITY_VALUE,
  payload: { position, value },
});

export const updateSort = (sort: TtSortByOption) => ({
  type: UPDATE_SORT,
  payload: { sort },
});

export const setIsAggregationEnabledDefaultValue = (
  isAggregationEnabledDefaultValue: boolean
) => ({
  type: SET_AGGREGATION_ENABLED_DEFAULT_VALUE,
  payload: { isAggregationEnabledDefaultValue },
});

export const setAggregationType = (aggregationType: AggregationTypes) => ({
  type: SET_AGGREGATION_TYPE,
  payload: { aggregationType },
});

export function getTTQuotationDetails(id: string, sort?: string) {
  const defaultUrl = `${QUOTE_TO_ORDER_BASE_URL}/${id}`;
  const url = sort ? `${defaultUrl}?sort=${sort}` : defaultUrl;
  return (dispatch) => {
    dispatch(fetchTTQuotToOrderDetailsBegin());
    return fetch(url, { credentials: "same-origin" })
      .then((res) => {
        if (!res.ok) {
          throw new ErrorResponseWrapper(res);
        }
        return res.json();
      })
      .then((data) => {
        sort ? dispatch(updateSort(sort as TtSortByOption)) : null;
        dispatch(fetchTTQuotToOrderDetailsSuccess(data));
        return data;
      })
      .catch((errorResponse: ErrorResponseWrapper) => {
        errorResponse.getErrorMessages().then((messages) => {
          dispatch(fetchTTQuotToOrderDetailsFailure(messages));
        });
      });
  };
}

export function chanageTTQuotToOrderDetQuontity(val: boolean) {
  return (dispatch) => {
    dispatch(changeTTQuotToOrderDetailsQuontity(val));
  };
}

export function changeTTQuontityValue(position: number, val: number) {
  return (dispatch) => {
    dispatch(changeTTQuotToOrderValue(position, val));
  };
}

export const addQuoteToOrderToCartBegin = () => ({
  type: ADD_QUOTE_TO_ORDER_TO_CART_BEGIN,
});

export const addQuoteToOrderToCartSuccess = () => ({
  type: ADD_QUOTE_TO_ORDER_TO_CART_SUCCESS,
});

export const addQuoteToOrderToCartFailure = (errors) => ({
  type: ADD_QUOTE_TO_ORDER_TO_CART_FAILURE,
  payload: { errors },
});

export const updateQuoteToOrderSelectedItems = (
  selectedItems: Array<number>
) => ({
  type: UPDATE_QUOTE_TO_ORDER_SELECTED_ITEMS,
  payload: { selectedItems },
});

export function addQuoteToOrderToCart(
  id: string,
  request: ITtAddQuoteToOrderToCartRequest
) {
  const url = `${QUOTE_TO_ORDER_BASE_URL}/${id}/checkout`;
  const requestParams: RequestInit = {
    credentials: "same-origin",
    method: "POST",
    body: JSON.stringify(request),
    headers: {
      "Content-Type": "application/json",
    },
  };

  return (dispatch) => {
    dispatch(addQuoteToOrderToCartBegin());
    return fetch(url, requestParams)
      .then((res) => {
        if (!res.ok) throw new ErrorResponseWrapper(res);
        dispatch(addQuoteToOrderToCartSuccess());
        window.location.assign(config.cartConfig.cartPageUrl);
      })
      .catch((errorResponse: ErrorResponseWrapper) => {
        errorResponse.getTTErrorMessages().then((messages) => {
          dispatch(addQuoteToOrderToCartFailure(messages));
          window.scrollTo({ top: 0, behavior: "smooth" });
        });
      });
  };
}

export const downloadQuoteToOrderPdfBegin = () => ({
  type: DOWNLOAD_QUOTE_TO_ORDER_BEGIN,
});
export const downloadQuoteToOrderPdfSuccess = () => ({
  type: DOWNLOAD_QUOTE_TO_ORDER_SUCCESS,
});

export const downloadQuoteToOrderPdfFailure = (errors) => ({
  type: DOWNLOAD_QUOTE_TO_ORDER_FAILURE,
  payload: { errors },
});

export const downloadQuoteToOrderPdfNotFoundFailure = (errors) => ({
  type: DOWNLOAD_QUOTE_TO_ORDER_NOT_FOUND_FAILURE,
  payload: { errors },
});

export const toggleErrorModal = () => ({
  type: TOGGLE_ERROR_MODAL,
});

export function downloadQuoteToOrderPdf(id: string, isPreview: boolean) {
  const url = `${QUOTE_TO_ORDER_BASE_URL}/${id}/download`;

  return async (dispatch): Promise<void> => {
    dispatch(downloadQuoteToOrderPdfBegin());
    try {
      const res = await fetch(url, { credentials: "same-origin" });
      if (!res.ok) {
        throw new ErrorResponseWrapper(res);
      }

      const downloadLink = document.createElement("a");
      document.body.appendChild(downloadLink);

      if (isPreview) {
        downloadLink.href = url;
        downloadLink.target = "_blank";
      } else {
        const blobResponse = await res.blob();
        const urlCreator = window.URL || window.webkitURL;
        const contentDisposition = res.headers.get("Content-Disposition");

        downloadLink.href = urlCreator.createObjectURL(blobResponse);
        downloadLink.download =
          getContentDispositionFileName(contentDisposition);
      }

      downloadLink.click();
      downloadLink.remove();
      window.URL.revokeObjectURL(url);
      dispatch(downloadQuoteToOrderPdfSuccess());
    } catch (errorResponse) {
      errorResponse.getTTErrorMessages().then((messages) => {
        const { isNotFoundError, responseJSON } = messages;

        isNotFoundError
          ? dispatch(downloadQuoteToOrderPdfNotFoundFailure(responseJSON))
          : dispatch(downloadQuoteToOrderPdfFailure(messages));
      });
    }
  };
}
